<template>
<div class="chapter">
<div class="inner_page">
<a id="page_7"></a>
<h2 class="cn">Table of Contents</h2>
<h2 class="toc"><a href="#/xhtml/04_Chapter1">Usher</a></h2>
<h2 class="toc"><a href="#/xhtml/05_Chapter2">The Penny Is for God!</a></h2>
<h2 class="toc"><span href="#/xhtml/06_Chapter3" title="Link target outside of Sample">Tessie, Don’t Give Away the Raisin; without It, You’re Lost!</span></h2>
<h2 class="toc"><span href="#/xhtml/07_Chapter4" title="Link target outside of Sample">Free the Canaries from Their Cages!</span></h2>
<h2 class="toc"><span href="#/xhtml/08_Chapter5" title="Link target outside of Sample">No Golden Tombstones for Me!</span></h2>
<h2 class="toc"><span href="#/xhtml/09_Chapter6" title="Link target outside of Sample">They’re Killing Jews on Sackman Street!</span></h2>
<h2 class="toc"><span href="#/xhtml/10_Chapter7" title="Link target outside of Sample">Fire Is Burning on Our Street!</span></h2>
<h2 class="toc"><span href="#/xhtml/11_Chapter8" title="Link target outside of Sample">Come into the Hallway, for Five Cents!</span></h2>
<h2 class="toc"><span href="#/xhtml/12_Chapter9" title="Link target outside of Sample">“When We Produce Prostitutes and Thieves, We Shall Be a Normal People!”—Jabotinsky</span></h2>
<a id="page_8"></a>
<h2 class="toc"><span href="#/xhtml/13_Chapter10" title="Link target outside of Sample">Hello, Lenin! Hello, Stalin! How’s the Revolution Today?</span></h2>
<h2 class="toc"><span href="#/xhtml/14_Chapter11" title="Link target outside of Sample">Songs My Mother Taught Me That Are Not in <em class="italic">Hamlet;</em> or, “Come into My House, Horatio! There Are More Things under the Mattress than Are Dreamt of in Your Philosophy!”</span></h2>
<h2 class="toc"><span href="#/xhtml/15_Chapter12" title="Link target outside of Sample">I Went to the Market Place to See the World! Oy, Mama, Oy!</span></h2>
<h2 class="toc"><span href="#/xhtml/16_Chapter13" title="Link target outside of Sample">With a Herring in One Hand and a Bottle of Schnapps in the Other; Oh! How He Did Dance!</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?c8aefb16